import { StaticEntity } from './static-entity'

export const Item = ({ x, y, width = 16, height = 16, config = {} }) =>
  <StaticEntity x={x} y={y} width={width} height={height} entityType="item" config={config} />
